"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Strings = void 0;
/**
 * A utility class for string manipulation.
 */
class Strings {
    /**
     * Capitalizes the first letter of a given string.
     *
     * @param {string} str The input string.
     * @returns {string} The string with the first letter capitalized, or the original string if it's empty or null.
     */
    static ucFirstLetter(str) {
        return str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
    }
}
exports.Strings = Strings;
